import checklistFeatures from "@csrc/modules/checklist/assets/data/constants/featuresArr"
import {analyticsFeatures} from "@csrc/modules/analytics"
import {settingsFeatures} from "@csrc/modules/settings"
import {issuesFeatures} from "@csrc/modules/issues"
import {features as fworkFeatures} from "@src/assets/data/constants"

export const features = {
  ...fworkFeatures,
  ...issuesFeatures,
  ...checklistFeatures,
  ...analyticsFeatures,
  ...settingsFeatures
}
